import { AlertTriangle } from "lucide-react";

/**
 * Badge "curva desatualizada" (#40) — as-o da curva forward parou de avancar.
 *
 * Fecha o ciclo do incidente-curva-0907: a Mesa esqueceu de publicar a curva no
 * Zeus, o cron da manha usou D-1 e o snapshot/pnl sairam congelados — SEM alarme
 * (o cron ficou verde). Este badge e honesto sobre a as-of do DADO (data_ref_zeus),
 * nao a idade do cron. So aparece quando `stale` (>= 2 dias uteis atras); 1 dia
 * util atras (D-1 legitimo da manha) NAO acende.
 *
 * Puro/presentacional: renderiza null quando nao-stale (some sozinho quando a
 * curva volta a avancar). Tom vermelho pra distinguir de "estimativa" (ambar).
 */
export function CurvaStaleBadge({
  stale,
  asOf,
}: {
  /** true = as-of >= 2 dias uteis atras (backend `curva_stale`). */
  stale?: boolean | null;
  /** as-of do dado (ISO date, `data_ref_zeus`), pro label DD/MM. */
  asOf?: string | null;
}) {
  if (!stale) return null;
  const label = asOf ? formatAsOf(asOf) : "—";
  return (
    <span
      className="inline-flex items-center gap-1 text-[10px] uppercase tracking-wider text-red-200/90 bg-red-500/10 border border-red-400/30 px-2 py-0.5 rounded"
      data-testid="curva-stale-badge"
      title={
        `A curva forward do Zeus nao avancou (as-of ${label}). As telas ` +
        `curva-dependentes (Fluxo, PnL, Curva, Posicao) estao marcadas com uma ` +
        `curva antiga. Suba a curva no Zeus e re-rode o sync (incidente-curva-0907).`
      }
    >
      <AlertTriangle size={10} />
      Curva desatualizada · as-of {label}
    </span>
  );
}

/** ISO "2026-07-08" -> "08/07". Sem timezone (a data e civil, nao instante). */
function formatAsOf(iso: string): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  if (!m) return iso;
  return `${m[3]}/${m[2]}`;
}
